import { TabelaVirtualizadaGenerica } from "components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import { colunasEmpresaInicial } from "contexts/ContextConstants.ts";
import { useEmbarqueDependencias } from "contexts/EmbarqueDependenciasContext.tsx";
import CadastroEditHeader from "core/components/CadastroEditHeader.tsx";
import MotionContainer from "core/components/MotionContainer.tsx";
import Separator from "core/components/Separator.tsx";
import Layout from "core/layout/Layout.tsx";
import { AnimatePresence } from "framer-motion";
import { useRowClick } from "hooks/useRowClick.ts";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { getArquivoPorUrlBlob } from "services/ModuloGerenciador/Midia.js";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import ModalVeiculo from "../../../components/ModalVeiculo/ModalVeiculo.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import NomeTabelaRedux from "../../../contexts/NomeTabela";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import {
	deleteDocs,
	deleteDocsCarreta,
	salvaDocs,
} from "../../../services/ModuloGerenciador/GoogleStorage.js";
import {
	cadastraCarretaDocumento,
	cadastraVeiculoDocumento,
	deleteVeiculoDocumentoPorId,
	editaVeiculoDocumentoPorId,
	getVeiculoDocumento,
	getVeiculoDocumentoPorId,
	salvaDocsCarreta,
} from "../../../services/ModuloGerenciador/VeiculoDocumento.js";
import "./Documentacao.css";

const documentos = [
	{ id: "Antt", label: "ANTT", preview: "antt", loading: "antt" },
	{ id: "Crlv", label: "CRLV", preview: "crlv", loading: "crlv" },
	{
		id: "CnhMotorista",
		label: "CNH",
		preview: "cnhMotorista",
		loading: "cnhMotorista",
	},
	{
		id: "ComprovanteResidencia",
		label: "Comprovante Residência",
		preview: "comprovanteResidencia",
		loading: "comprovanteResidencia",
	},
	{
		id: "FotoVeiculo",
		label: "Foto do Veículo",
		preview: "fotoVeiculo",
		loading: "fotoVeiculo",
	},
];

const documentosCarreta = [
	{
		id: "Antt",
		label: "ANTT",
		preview: "antt",
		valor: "anttCarreta",
		loading: "anttCarreta",
	},
	{
		id: "Crlv",
		label: "CRLV",
		preview: "crlv",
		valor: "crlvCarreta",
		loading: "crlvCarreta",
	},
	{
		id: "FotoVeiculo",
		label: "Foto do Veículo",
		preview: "fotoVeiculo",
		valor: "fotoVeiculoCarreta",
		loading: "fotoVeiculo",
	},
];

const documentosCarreta2 = [
	{
		id: "Antt",
		label: "ANTT",
		preview: "antt",
		valor: "anttCarreta2",
		loading: "anttCarreta2",
	},
	{
		id: "Crlv",
		label: "CRLV",
		preview: "crlv",
		valor: "crlvCarreta2",
		loading: "crlvCarreta2",
	},
	{
		id: "FotoVeiculo",
		label: "Foto do Veículo",
		preview: "fotoVeiculo",
		valor: "fotoVeiculoCarreta2",
		loading: "fotoVeiculo",
	},
];

const fieldsToCheck = [
	"dataValidadeAntt",
	"dataValidadeCnhMotorista",
	"dataValidadeComprovanteResidencia",
	"dataValidadeCrlv",
	"dataValidadeFotoVeiculo",
];

function Documentacao(props) {
	const { profile, hasRegra } = useProfile();

	const hasBuscadoInicial = useRef(false);
	const remotePreviewsRef = useRef({});
	const pendingRemoteRef = useRef(new Set());

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { fetchVeiculos } = useEmbarqueDependencias();

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [openToastSucesso, setOpenToastSucesso] = useState(false);
	const [openToastErro, setOpenToastErro] = useState(false);
	const [openUsuario, setOpenUsuario] = useState(false);
	const [openModalVeiculos, setOpenModalVeiculos] = useState(false);
	const [veiculo, setVeiculo] = useState(null);
	const [carreta, setCarreta] = useState(null);
	const [carretaId, setCarretaId] = useState(null);
	const [carreta2, setCarreta2] = useState(null);
	const [carretaId2, setCarretaId2] = useState(null);
	const [valuesDoc, setValuesDoc] = useState({
		antt: null,
		crlv: null,
		cnh: null,
		comprovanteResidencia: null,
		fotoVeiculo: null,
	});
	const [previews, setPreviews] = useState({
		antt: null,
		crlv: null,
		cnh: null,
		comprovanteResidencia: null,
		fotoVeiculo: null,
	});
	const [previewsCarreta, setPreviewsCarreta] = useState({
		antt: null,
		crlv: null,
		fotoVeiculo: null,
	});
	const [previewsCarreta2, setPreviewsCarreta2] = useState({
		antt: null,
		crlv: null,
		fotoVeiculo: null,
	});
	const [remotePreviews, setRemotePreviews] = useState({});
	const [tipoDocAtual, setTipoDocAtual] = useState(null);
	const [docValor, setDocValor] = useState(null);
	const [docIdAtual, setDocIdAtual] = useState(null);
	const [veiculoDocIdAtual, setVeiculoDocIdAtual] = useState(null);
	const [veiculoDocCarretaIdAtual, setVeiculoDocCarretaIdAtual] =
		useState(null);
	const [loadingDocs, setLoadingDocs] = useState({});
	const [openConfirmar, setOpenConfirmar] = useState(false);
	const [openConfirmar2, setOpenConfirmar2] = useState(false);
	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const handleClose = (value) => {
		setOpen(false);
	};

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const handleCloseModalVeiculos = () => {
		setOpenModalVeiculos(false);
		setVeiculo(null);
	};

	const buscarDocumentacao = async () => {
		if (!profile) return;
		setLoading(true);
		await getVeiculoDocumento(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const cadastrar = async () => {
		setLoading(true);
		await cadastraVeiculoDocumento({ veiculoId: veiculo }, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setVeiculo(result.data?.idVeiculoDocumento);
					setCarreta(result.data?.carretaDocumento?.id);
					setCarretaId(result.data?.veiculo?.carretaId);
					setCarreta2(result.data?.carretaDocumento2?.id);
					setCarretaId2(result.data?.veiculo?.carreta2Id);
					buscarDocumentacao();
					setDadosRequestControllerRedux("Fechar Modal Documentacao");
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setOpenModalVeiculos(false);
					setTelaCadastro(true);
					setValues(result.data);
					setTabelaRedux({ colunaSelecionada: result.data.idVeiculoDocumento });
					setPreviews({});
					setPreviewsCarreta({});
					setPreviewsCarreta2({});
					clearRemotePreviews();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const editar = async () => {
		setLoading(true);
		await editaVeiculoDocumentoPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarDocumentacao();
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const preencherData = (baseValues, dados) => {
		const valoresIniciais = { ...baseValues };

		documentos.forEach((doc) => {
			const key = `dataValidade${doc.id}${doc.valor ? doc.valor : ""}`;
			if (dados?.[key]) {
				valoresIniciais[key] = new Date(dados[key]).toISOString().split("T")[0];
			}
		});

		documentosCarreta.forEach((doc) => {
			const key = `dataValidade${doc.id}${doc.valor ? doc.valor : ""}`;
			const key2 = `dataValidade${doc.id}`;
			const dado = dados?.carretaDocumento;
			if (dado && dado[key2]) {
				valoresIniciais[key] = new Date(dado[key2]).toISOString().split("T")[0];
			}
		});

		documentosCarreta2.forEach((doc) => {
			const key = `dataValidade${doc.id}${doc.valor ? doc.valor : ""}`;
			const key2 = `dataValidade${doc.id}`;
			const dado = dados?.carretaDocumento2;
			if (dado && dado[key2]) {
				valoresIniciais[key] = new Date(dado[key2]).toISOString().split("T")[0];
			}
		});

		return valoresIniciais;
	};

	const handleCloseConfirmar = (value) => {
		setOpenConfirmar(false);
	};

	const handleCloseConfirmar2 = (value) => {
		setOpenConfirmar2(false);
	};

	const buscarDocumentacaoPorId = async () => {
		setLoading(true);
		await getVeiculoDocumentoPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					setLoading(false);
					setValues((prev) => {
						const merged = mergeNonNull(prev, result.data);
						return preencherData(merged, result.data);
					});
					setVeiculo(result.data.idVeiculoDocumento);
					setCarreta(result.data.carretaDocumento?.id);
					setCarretaId(result.data.veiculo.carretaId);
					setCarreta2(result.data.carretaDocumento2?.id);
					setCarretaId2(result.data.veiculo.carreta2Id);
					clearRemotePreviews();
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const isPlainObject = (v) =>
		v !== null &&
		typeof v === "object" &&
		!Array.isArray(v) &&
		!(v instanceof Date) &&
		!(v instanceof File) &&
		!(v instanceof Blob);

	const isEmptyPlainObject = (v) =>
		isPlainObject(v) && Object.keys(v).length === 0;

	const mergeNonNull = (prev, incoming) => {
		if (incoming === null || incoming === undefined) return prev;

		if (Array.isArray(incoming)) return incoming;

		if (isPlainObject(incoming)) {
			const base = isPlainObject(prev) ? prev : {};
			const out = { ...base };

			for (const [key, val] of Object.entries(incoming)) {
				if (val === null || val === undefined) continue;

				if (isEmptyPlainObject(val)) continue;

				const prevVal = base[key];

				if (prevVal instanceof File || prevVal instanceof Blob) continue;

				if (isPlainObject(val)) out[key] = mergeNonNull(prevVal, val);
				else out[key] = val;
			}

			return out;
		}

		return incoming;
	};

	const buscarDocumentacaoPorIdParam = async (id, flag = false) => {
		setLoadingDoc(id, true);
		await getVeiculoDocumentoPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					setTimeout(() => {
						setLoadingDoc(id, false);
					}, 100);
					if (flag) {
						setValues(result.data);
					} else {
						setValues((prev) => {
							const merged = mergeNonNull(prev, result.data);
							return preencherData(merged, result.data);
						});
					};
					setVeiculo(result.data.idVeiculoDocumento);
					setCarreta(result.data.carretaDocumento?.id);
					setCarretaId(result.data.veiculo.carretaId);
					setCarreta2(result.data.carretaDocumento2?.id);
					setCarretaId2(result.data.veiculo.carreta2Id);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarDocumentacaoPorIdModal = async (id) => {
		setLoading(true);
		await getVeiculoDocumentoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
					clearRemotePreviews();
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarDocumentacaoPorId = async () => {
		setLoading(true);
		await deleteVeiculoDocumentoPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					buscarDocumentacao();
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const clearRemotePreviews = useCallback(() => {
		setRemotePreviews((prev) => {
			Object.values(prev).forEach((u) => {
				try {
					URL.revokeObjectURL(u);
				} catch { }
			});
			return {};
		});
		pendingRemoteRef.current = new Set();
	}, []);

	const invalidateRemotePreview = useCallback((cacheKey) => {
		setRemotePreviews((prev) => {
			if (!prev?.[cacheKey]) return prev;
			const next = { ...prev };
			const old = next[cacheKey];
			try {
				URL.revokeObjectURL(old);
			} catch { }
			delete next[cacheKey];
			return next;
		});
	}, []);

	const decodeBase64ToUint8Array = (base64) => {
		const binary = atob(base64);
		const bytes = new Uint8Array(binary.length);
		for (let i = 0; i < binary.length; i++) {
			bytes[i] = binary.charCodeAt(i);
		}
		return bytes;
	};

	const ensureRemotePreview = useCallback(
		async (cacheKey, docName) => {
			if (!profile?.token) return;
			if (!docName) return;
			if (remotePreviewsRef.current?.[cacheKey]) return;
			if (pendingRemoteRef.current.has(cacheKey)) return;

			pendingRemoteRef.current.add(cacheKey);

			try {
				const safeName = encodeURIComponent(docName);
				const res = await getArquivoPorUrlBlob(safeName, profile?.token);

				const contentType =
					res?.headers?.["content-type"] || res?.data?.type || "";

				let objectUrl = null;

				if (String(contentType).includes("application/json")) {
					const text = await res.data.text();
					const json = JSON.parse(text);

					const base64 = json.dado || json.Dado || "";
					const mime = json.tipo || json.Tipo || "application/octet-stream";

					if (base64) {
						const bytes = decodeBase64ToUint8Array(base64);
						const blob = new Blob([bytes], { type: mime });
						objectUrl = URL.createObjectURL(blob);
					}
				}

				if (!objectUrl) {
					const blob =
						res.data instanceof Blob ? res.data : new Blob([res.data]);
					objectUrl = URL.createObjectURL(blob);
				}

				setRemotePreviews((prev) => ({ ...prev, [cacheKey]: objectUrl }));
			} catch {
			} finally {
				pendingRemoteRef.current.delete(cacheKey);
			}
		},
		[profile?.token],
	);

	useEffect(() => {
		if (!profile?.token) return;

		documentos.forEach((doc) => {
			const cacheKey = doc.id;
			const hasLocal = !!previews?.[cacheKey];
			const docName = values?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});

		documentosCarreta.forEach((doc) => {
			const cacheKey = `${doc.id}_${doc.valor}`;
			const hasLocal = !!previewsCarreta?.[cacheKey];
			const docName = values?.carretaDocumento?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});

		documentosCarreta2.forEach((doc) => {
			const cacheKey = `${doc.id}_${doc.valor}`;
			const hasLocal = !!previewsCarreta2?.[cacheKey];
			const docName = values?.carretaDocumento2?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});
	}, [
		profile?.token,
		values,
		previews,
		previewsCarreta,
		previewsCarreta2,
		ensureRemotePreview,
	]);

	useEffect(() => {
		return () => {
			Object.values(remotePreviewsRef.current || {}).forEach((u) => {
				try {
					URL.revokeObjectURL(u);
				} catch { }
			});
		};
	}, []);

	const handleFileChange = (e, tipoDocumento) => {
		const file = e.target.files[0];
		if (file) {
			setValues((current) => ({
				...current,
				[tipoDocumento]: file,
			}));
			setPreviews((current) => ({
				...current,
				[tipoDocumento]: URL.createObjectURL(file),
			}));
			invalidateRemotePreview(tipoDocumento);
		}
	};

	const handleFileChangeCarreta = (e, tipoDocumento) => {
		const file = e.target.files[0];
		if (file) {
			const key = `${tipoDocumento.id}_${tipoDocumento.valor}`;
			setValues((current) => ({
				...current,
				[key]: file,
			}));
			setPreviewsCarreta((current) => ({
				...current,
				[key]: URL.createObjectURL(file),
			}));
			invalidateRemotePreview(key);
		}
	};

	const handleFileChangeCarreta2 = (e, tipoDocumento) => {
		const file = e.target.files[0];
		if (file) {
			const key = `${tipoDocumento.id}_${tipoDocumento.valor}`;
			setValues((current) => ({
				...current,
				[key]: file,
			}));
			setPreviewsCarreta2((current) => ({
				...current,
				[key]: URL.createObjectURL(file),
			}));
			invalidateRemotePreview(key);
		}
	};

	const handleSave = async (tipoDocumento) => {
		const dataValidade =
			values[
			`dataValidade${tipoDocumento.id}${tipoDocumento.valor ? tipoDocumento.valor : ""
			}`
			];
		const documento = values[`${tipoDocumento.id}`];
		if (!dataValidade && documento === undefined) {
			setTextoErro(
				"Por favor, insira uma data de validade e uma arquivo válido.",
			);
			setOpenToastErro(true);
			return;
		}

		if (
			documento === undefined &&
			values[`${tipoDocumento.preview}`] === null
		) {
			setTextoErro("Por favor, insira um arquivo válido.");
			setOpenToastErro(true);
			return;
		}

		if (!dataValidade) {
			setTextoErro("Por favor, insira uma data de validade válida.");
			setOpenToastErro(true);
			return;
		}

		let formData;
		if (documento) {
			formData = new FormData();
			formData.append("file", documento);
		}

		await salvaDocs(
			tipoDocumento.id,
			formData,
			values.idVeiculoDocumento,
			dataValidade,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					invalidateRemotePreview(tipoDocumento.id);
					buscarDocumentacaoPorIdParam(tipoDocumento.loading);
					setDadosRequestControllerRedux("Fechar Modal Documentacao");
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setOpenModalVeiculos(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const handleSaveCarreta = async (tipoDocumento) => {
		if (carreta) {
			salvarDocCarreta(tipoDocumento, carreta);
		} else {
			const objeto = {
				usuario: values.usuario,
				carretaId: carretaId,
			};
			await cadastraCarretaDocumento(objeto, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setCarreta(result.data.id);
						salvarDocCarreta(tipoDocumento, result.data.id);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	const handleSaveCarreta2 = async (tipoDocumento) => {
		if (carreta2) {
			salvarDocCarreta(tipoDocumento, carreta2);
		} else {
			const objeto = {
				usuario: values.usuario,
				carretaId: carretaId2,
			};
			await cadastraCarretaDocumento(objeto, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setCarreta2(result.data.id);
						salvarDocCarreta(tipoDocumento, result.data.id);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	const salvarDocCarreta = async (tipoDocumento, docId) => {
		const formData = new FormData();
		formData.append(
			"file",
			values[`${tipoDocumento.id}_${tipoDocumento.valor}`],
		);
		const dataValidade =
			values[`dataValidade${tipoDocumento.id}${tipoDocumento.valor}`];
		const documento = values[`${tipoDocumento.id}_${tipoDocumento.valor}`];

		if (!dataValidade || documento === undefined) {
			setTextoErro(
				"Por favor, insira uma data de validade e uma arquivo válido.",
			);
			setOpenToastErro(true);
			return;
		}

		await salvaDocsCarreta(
			tipoDocumento.id,
			formData,
			docId,
			dataValidade,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					invalidateRemotePreview(`${tipoDocumento.id}_${tipoDocumento.valor}`);
					buscarDocumentacaoPorIdParam(tipoDocumento.loading);
					setDadosRequestControllerRedux("Fechar Modal Documentacao");
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
					setOpenModalVeiculos(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const deletarAnexo = async () => {
		await deleteDocs(
			tipoDocAtual,
			docIdAtual,
			veiculoDocIdAtual,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					invalidateRemotePreview(tipoDocAtual);
					buscarDocumentacaoPorIdParam(docValor, true);
					setDadosRequestControllerRedux("Fechar Modal Documentacao");
					setTextoSucesso("Deletado Com Sucesso");
					setOpenToastSucesso(true);
					setOpenModalVeiculos(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const deletarAnexoCarreta = async () => {
		await deleteDocsCarreta(
			tipoDocAtual,
			docIdAtual,
			veiculoDocCarretaIdAtual,
			profile?.token,
		)
			.then((result) => {
				if (result.status === 200) {
					invalidateRemotePreview(`${tipoDocAtual}_${docValor}`);
					buscarDocumentacaoPorId();
					setDadosRequestControllerRedux("Fechar Modal Documentacao");
					setTextoSucesso("Deletado Com Sucesso");
					setOpenToastSucesso(true);
					setOpenModalVeiculos(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const setLoadingDoc = (id, isLoading) => {
		setLoadingDocs((prevState) => ({
			...prevState,
			[id]: isLoading,
		}));
	};

	const documentos = [
		{ id: "Antt", label: "ANTT", preview: "antt", loading: "antt", idv2: "anttId" },
		{ id: "Crlv", label: "CRLV", preview: "crlv", loading: "crlv", idv2: "crlvId" },
		{
			id: "CnhMotorista",
			label: "CNH",
			preview: "cnhMotorista",
			loading: "cnhMotorista",
			idv2: "cnhMotoristaId",
		},
		{
			id: "ComprovanteResidencia",
			label: "Comprovante Residência",
			preview: "comprovanteResidencia",
			loading: "comprovanteResidencia",
			idv2: "comprovanteResidenciaId",
		},
		{
			id: "FotoVeiculo",
			label: "Foto do Veículo",
			preview: "fotoVeiculo",
			loading: "fotoVeiculo",
			idv2: "fotoVeiculoId",
		},
	];

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row.idVeiculoDocumento,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux],
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, [setEditando, setTelaCadastro]);

	const handleRowClick = useRowClick({
		idKey: "idVeiculoDocumento",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idVeiculoDocumento === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada],
	);

	const handleCellClassName = useCallback((coluna, row, _rowIndex) => {
		const field = coluna?.field ?? coluna?.campo ?? coluna?.nome;
		if (!field) return undefined;

		const today = new Date();

		const classes = [];

		const hasExpiredField = fieldsToCheck.some(
			(field) => row[field] && new Date(row[field]) < today,
		);
		if (
			coluna.objetoDocumentacao1 === "true" &&
			row.veiculo?.caminhao &&
			coluna.field === "placa" &&
			hasExpiredField
		) {
			classes.push("data-piscando-1");
		}

		return classes.length ? classes.join(" ") : undefined;
	}, []);

	const renderCell = useCallback((coluna, row) => {
		if (coluna.objetoEndereco === "true") {
			const endereco = row.endereco;
			if (!endereco) return "";

			return `${endereco.rua ?? ""}, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""
				} - ${endereco.cidade ?? ""}`;
		}
		if (coluna.field === "placa") {
			return row.veiculo?.caminhao?.placa;
		}
		if (coluna.objetoDocumentacao2 === "true") {
			return row.veiculo?.proprietarioVeiculo?.nome;
		}
		if (coluna.objetoDocumentacao3 === "true") {
			return row.veiculo?.veiculoMotorista?.nome;
		}

		return undefined;
	}, []);

	useEffect(() => {
		if (!profile?.token) return;

		documentos.forEach((doc) => {
			const cacheKey = doc.id;
			const hasLocal = !!previews?.[cacheKey];
			const docName = values?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});

		documentosCarreta.forEach((doc) => {
			const cacheKey = `${doc.id}_${doc.valor}`;
			const hasLocal = !!previewsCarreta?.[cacheKey];
			const docName = values?.carretaDocumento?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});

		documentosCarreta2.forEach((doc) => {
			const cacheKey = `${doc.id}_${doc.valor}`;
			const hasLocal = !!previewsCarreta2?.[cacheKey];
			const docName = values?.carretaDocumento2?.[doc.preview]?.documentoUrl;
			if (!hasLocal && docName) ensureRemotePreview(cacheKey, docName);
		});
	}, [
		profile?.token,
		values,
		previews,
		previewsCarreta,
		previewsCarreta2,
		ensureRemotePreview,
	]);

	useEffect(() => {
		return () => {
			Object.values(remotePreviewsRef.current || {}).forEach((u) => {
				try {
					URL.revokeObjectURL(u);
				} catch { }
			});
		};
	}, []);

	useEffect(() => {
		if (editando) {
			buscarDocumentacaoPorId();
		}
	}, [editando]);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	useEffect(() => {
		if (profile?.token && !hasBuscadoInicial.current) {
			setSemAutorizacao(!hasRegra("Documentação"));
			buscarDocumentacao();
			fetchVeiculos(profile?.token);
			if (props.idAtual) {
				buscarDocumentacaoPorIdModal(props.idAtual);
			}
			hasBuscadoInicial.current = true;
		}
	}, [
		profile?.token,
		hasRegra,
		props.idAtual,
		buscarDocumentacaoPorIdModal,
		buscarDocumentacao,
	]);

	useEffect(() => {
		remotePreviewsRef.current = remotePreviews;
	}, [remotePreviews]);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Documentação";
		if (telaCadastro) return "Cadastro de Documentação";
		return "Documentação";
	}, [editando, telaCadastro]);

	const isLoading = useMemo(() => {
		return (
			loading ||
			!profile?.token ||
			(!dadosTabela.length && !hasBuscadoInicial.current)
		);
	}, [loading, profile?.token, dadosTabela.length]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer animationKey="DocumentacaoScreenContainer">
						<div className="content-container">
							<Separator size="md" />
							<TabelaVirtualizadaGenerica
								isLoading={isLoading}
								dados={dadosTabela}
								colunas={colunasEmpresaInicial.Documentacao}
								getRowClassName={getRowClassName}
								getCellClassName={handleCellClassName}
								onRowClick={handleRowClick}
								renderCell={renderCell}
								rowHeight={18}
								columnWidthsOverride
							/>
							<div className="footer-container">
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setOpenModalVeiculos(true);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer
						scroll
						animationKey="DocumentacaoScreenCadastroContainer"
					>
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<CadastroEditHeader
									dadosTitle="Dados de Documentação"
									headerTitle={
										editando
											? "Detalhes de Documentação"
											: "Cadastro de Documentação"
									}
									onClick={() => {
										setValues({});
										setVeiculo({});
										setPreviews({});
										setCarreta({});
										setCarretaId({});
										setPreviewsCarreta({});
										setCarreta2({});
										setCarretaId2({});
										setPreviewsCarreta2({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
										clearRemotePreviews();
										buscarDocumentacao();
									}}
								/>
							)}
							<Separator size="lg" />

							<div className="documentos-container">
								{!props.botaoVoltar && (
									<div>
										<p className="indicador-emb">
											Placa Veículo: <b>{values?.veiculo?.caminhao?.placa}</b>
										</p>
									</div>
								)}
								<div className="documentos-wrapper">
									{documentos.map((doc) => {
										const cacheKey = doc.id;
										const hasDoc =
											!!previews[cacheKey] ||
											!!values?.[doc.preview]?.documentoUrl;
										const resolvedUrl =
											previews[cacheKey] || remotePreviews[cacheKey];

										const isImage =
											values[doc.id]?.type?.includes("image") ||
											values?.[doc.preview]?.documentoUrl?.match(
												/\.(jpeg|jpg|png|gif|webp)$/i,
											);

										const isPdf =
											values?.[doc.preview]?.documentoUrl?.match(/\.pdf$/i) ||
											values[doc.id]?.type?.includes("pdf");

										return (
											<div key={doc.id} className="card-documento">
												<p className="documento-label">{doc.label}</p>

												{loadingDocs[doc.loading] ? (
													<div className="loading-indicator">
														<LoadingComponent />
													</div>
												) : (
													<div className="preview-container">
														{hasDoc && (
															<div className="preview-container">
																{resolvedUrl ? (
																	isImage ? (
																		<img
																			src={resolvedUrl}
																			alt={`${doc.label} Preview`}
																			className="preview-image"
																			onClick={() =>
																				window.open(resolvedUrl, "_blank")
																			}
																		/>
																	) : isPdf ? (
																		<iframe
																			src={resolvedUrl}
																			className="preview-pdf"
																			title={`${doc.label} Preview`}
																			onClick={() =>
																				window.open(resolvedUrl, "_blank")
																			}
																		/>
																	) : (
																		<div className="preview-generic">
																			<p>
																				Arquivo não visualizável diretamente.
																			</p>
																		</div>
																	)
																) : (
																	<div className="loading-indicator">
																		<LoadingComponent />
																	</div>
																)}

																<div style={{ gap: 10, display: "flex" }}>
																	<button
																		onClick={() => {
																			if (resolvedUrl)
																				window.open(resolvedUrl, "_blank");
																		}}
																	>
																		Visualizar
																	</button>
																	{values[doc.preview] !== null && values[doc.idv2] !== undefined && (
																		<button
																			style={{ backgroundColor: "#ff0000" }}
																			onClick={() => {
																				if (values[doc.preview] !== null && values[doc.idv2] !== undefined) {
																					setOpenConfirmar(true);
																					setTipoDocAtual(doc.id);
																					setDocValor(doc.loading);
																					setDocIdAtual(values[doc.preview]?.idGoogleStorage);
																					setVeiculoDocIdAtual(values.idVeiculoDocumento);
																				} else {
																					setOpenToastErro(true);
																					setTextoErro(
																						"Não é possivel deletar este dococumento",
																					);
																				}
																			}}
																		>
																			Deletar
																		</button>
																	)}
																</div>
															</div>
														)}

														<div className="upload-container">
															<input
																type="file"
																className="input-file"
																onChange={(e) => handleFileChange(e, doc.id)}
															/>
															<input
																type="date"
																className="input-date"
																value={
																	values[
																	`dataValidade${doc.id}${doc.valor ? doc.valor : ""}`
																	] || ""
																}
																onChange={(e) => {
																	setValues((current) => ({
																		...current,
																		[`dataValidade${doc.id}${doc.valor ? doc.valor : ""}`]:
																			e.target.value,
																	}));
																}}
																placeholder="Data de Validade"
															/>
															<button onClick={() => handleSave(doc)}>
																Cadastrar
															</button>
														</div>
													</div>
												)}
											</div>
										);
									})}
								</div>
							</div>

							<Separator size="lg" />

							{values?.veiculo?.carreta && (
								<div className="documentos-container">
									<p className="indicador-emb" style={{ textAlign: "center" }}>
										Placa Carreta: <b>{values?.veiculo?.carreta?.placa}</b>
									</p>
									<div className="documentos-wrapper">
										{documentosCarreta.map((doc) => {
											const cacheKey = `${doc.id}_${doc.valor}`;
											const hasDoc =
												!!previewsCarreta[cacheKey] ||
												!!values?.carretaDocumento?.[doc.preview]?.documentoUrl;
											const resolvedUrl =
												previewsCarreta[cacheKey] || remotePreviews[cacheKey];

											const isImage =
												values[cacheKey]?.type?.includes("image") ||
												values?.carretaDocumento?.[
													doc.preview
												]?.documentoUrl?.match(/\.(jpeg|jpg|png|gif|webp)$/i);

											const isPdf =
												values?.carretaDocumento?.[
													doc.preview
												]?.documentoUrl?.match(/\.pdf$/i) ||
												values[cacheKey]?.type?.includes("pdf");

											return (
												<div key={doc.id} className="card-documento">
													<p className="documento-label">{doc.label}</p>
													{loadingDocs[doc.loading] ? (
														<div className="loading-indicator">
															<LoadingComponent />
														</div>
													) : (
														<div className="preview-container">
															{hasDoc ? (
																<div className="preview-container">
																	{resolvedUrl ? (
																		isImage ? (
																			<img
																				src={resolvedUrl}
																				alt={`${doc.label} Preview`}
																				className="preview-image"
																				onClick={() =>
																					window.open(resolvedUrl, "_blank")
																				}
																			/>
																		) : isPdf ? (
																			<iframe
																				src={resolvedUrl}
																				className="preview-pdf"
																				title={`${doc.label} Preview`}
																				onClick={() =>
																					window.open(resolvedUrl, "_blank")
																				}
																			></iframe>
																		) : (
																			<div className="preview-generic">
																				<p>
																					Arquivo não visualizável diretamente.
																				</p>
																			</div>
																		)
																	) : (
																		<div className="loading-indicator">
																			<LoadingComponent />
																		</div>
																	)}

																	<div style={{ gap: 10, display: "flex" }}>
																		<button
																			onClick={() => {
																				if (resolvedUrl)
																					window.open(resolvedUrl, "_blank");
																			}}
																		>
																			Visualizar
																		</button>

																		{values.carretaDocumento &&
																			values.carretaDocumento?.[doc.preview] !==
																			null && (
																				<button
																					style={{ backgroundColor: "#ff0000" }}
																					onClick={() => {
																						if (
																							values.carretaDocumento?.[
																							doc.preview
																							]
																						) {
																							setOpenConfirmar2(true);
																							setTipoDocAtual(doc.id);
																							setDocValor(doc.loading);
																							setDocIdAtual(
																								values.carretaDocumento[
																									doc.preview
																								].idGoogleStorage,
																							);
																							setVeiculoDocCarretaIdAtual(
																								values.carretaDocumento.id,
																							);
																						} else {
																							setOpenToastErro(true);
																							setTextoErro(
																								"Não é possivel deletar este dococumento",
																							);
																						}
																					}}
																				>
																					Deletar
																				</button>
																			)}
																	</div>
																</div>
															) : null}

															<div className="upload-container">
																<input
																	type="file"
																	className="input-file"
																	onChange={(e) =>
																		handleFileChangeCarreta(e, doc)
																	}
																/>
																<input
																	type="date"
																	className="input-date"
																	value={
																		values[
																		`dataValidade${doc.id}${doc.valor}`
																		] || ""
																	}
																	onChange={(e) => {
																		setValues((current) => ({
																			...current,
																			[`dataValidade${doc.id}${doc.valor}`]:
																				e.target.value,
																		}));
																	}}
																	placeholder="Data de Validade"
																/>
																<button onClick={() => handleSaveCarreta(doc)}>
																	Cadastrar
																</button>
															</div>
														</div>
													)}
												</div>
											);
										})}
									</div>
								</div>
							)}

							<Separator size="lg" />

							{values?.veiculo?.carreta2 && (
								<div className="documentos-container">
									<p className="indicador-emb" style={{ textAlign: "center" }}>
										Placa Carreta 2: <b>{values?.veiculo?.carreta2?.placa}</b>
									</p>
									<div className="documentos-wrapper">
										{documentosCarreta2.map((doc) => {
											const cacheKey = `${doc.id}_${doc.valor}`;
											const hasDoc =
												!!previewsCarreta2[cacheKey] ||
												!!values?.carretaDocumento2?.[doc.preview]
													?.documentoUrl;
											const resolvedUrl =
												previewsCarreta2[cacheKey] || remotePreviews[cacheKey];

											const isImage =
												values[cacheKey]?.type?.includes("image") ||
												values?.carretaDocumento2?.[
													doc.preview
												]?.documentoUrl?.match(/\.(jpeg|jpg|png|gif|webp)$/i);

											const isPdf =
												values?.carretaDocumento2?.[
													doc.preview
												]?.documentoUrl?.match(/\.pdf$/i) ||
												values[cacheKey]?.type?.includes("pdf");

											return (
												<div key={doc.id} className="card-documento">
													<p className="documento-label">{doc.label}</p>
													{loadingDocs[doc.loading] ? (
														<div className="loading-indicator">
															<LoadingComponent />
														</div>
													) : (
														<div className="preview-container">
															{hasDoc ? (
																<div className="preview-container">
																	{resolvedUrl ? (
																		isImage ? (
																			<img
																				src={resolvedUrl}
																				alt={`${doc.label} Preview`}
																				className="preview-image"
																				onClick={() =>
																					window.open(resolvedUrl, "_blank")
																				}
																			/>
																		) : isPdf ? (
																			<iframe
																				src={resolvedUrl}
																				className="preview-pdf"
																				title={`${doc.label} Preview`}
																				onClick={() =>
																					window.open(resolvedUrl, "_blank")
																				}
																			></iframe>
																		) : (
																			<div className="preview-generic">
																				<p>
																					Arquivo não visualizável diretamente.
																				</p>
																			</div>
																		)
																	) : (
																		<div className="loading-indicator">
																			<LoadingComponent />
																		</div>
																	)}

																	<div style={{ gap: 10, display: "flex" }}>
																		<button
																			onClick={() => {
																				if (resolvedUrl)
																					window.open(resolvedUrl, "_blank");
																			}}
																		>
																			Visualizar
																		</button>

																		{values.carretaDocumento2 &&
																			values.carretaDocumento2?.[
																			doc.preview
																			] && (
																				<button
																					style={{ backgroundColor: "#ff0000" }}
																					onClick={() => {
																						if (
																							values.carretaDocumento2?.[
																							doc.preview
																							]
																						) {
																							setOpenConfirmar2(true);
																							setTipoDocAtual(doc.id);
																							setDocValor(doc.loading);
																							setDocIdAtual(
																								values.carretaDocumento2[
																									doc.preview
																								].idGoogleStorage,
																							);
																							setVeiculoDocCarretaIdAtual(
																								values.carretaDocumento2.id,
																							);
																						} else {
																							setOpenToastErro(true);
																							setTextoErro(
																								"Não é possivel deletar este dococumento",
																							);
																						}
																					}}
																				>
																					Deletar
																				</button>
																			)}
																	</div>
																</div>
															) : null}

															<div className="upload-container">
																<input
																	type="file"
																	className="input-file"
																	onChange={(e) =>
																		handleFileChangeCarreta2(e, doc)
																	}
																/>
																<input
																	type="date"
																	className="input-date"
																	value={
																		values[
																		`dataValidade${doc.id}${doc.valor}`
																		] || ""
																	}
																	onChange={(e) => {
																		setValues((current) => ({
																			...current,
																			[`dataValidade${doc.id}${doc.valor}`]:
																				e.target.value,
																		}));
																	}}
																	placeholder="Data de Validade"
																/>
																<button onClick={() => handleSaveCarreta2(doc)}>
																	Cadastrar
																</button>
															</div>
														</div>
													)}
												</div>
											);
										})}
									</div>
								</div>
							)}
						</div>
					</MotionContainer>
				)}
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarDocumentacaoPorId}
				/>

				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>

				<ModalVeiculo
					titulo="Selecione um Veículo"
					tituloConfirmar="OK"
					open={openModalVeiculos}
					onClick={cadastrar}
					onClose={handleCloseModalVeiculos}
					setVeiculo={setVeiculo}
				/>

				<ModalConfirmacao2
					titulo="Deletar"
					texto="Deseja deletar este documento?"
					textoBotao="Sim"
					open={openConfirmar}
					onClose={handleCloseConfirmar}
					onClick={deletarAnexo}
				/>

				<ModalConfirmacao2
					titulo="Deletar"
					texto="Deseja deletar este documento?"
					textoBotao="Sim"
					open={openConfirmar2}
					onClose={handleCloseConfirmar2}
					onClick={deletarAnexoCarreta}
				/>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</AnimatePresence>
		</Layout>
	);
}

export default Documentacao;
